import { Modal, Button } from "react-bootstrap";

import "./ConditionalModal.scss";
import SuccessIcon from "../../assets/images/success.svg";
import GoldIcon from "../../assets/images/gold_rupe_icon.svg";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const ConditionalModalBillSucess = (props) => {
  const { text } = props;
  const [isMobile, setIsMobile] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600); // Adjust breakpoint as needed
    };

    // Check screen size on component mount
    handleResize();

    // Add event listener for window resize
    window.addEventListener("resize", handleResize);

    // Clean up event listener on unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered={!isMobile}
        className="conditional-modal slide-up-modal"
      >
        <Button
          type="button"
          className="custom-close mobile-close1"
          aria-label="Close"
          onClick={() => {
            props.onHide();
          }}
        >
          <span aria-hidden="true">&times;</span>
        </Button>

        <Modal.Header>
          <Modal.Title
            id="contained-modal-title-vcenter"
            className="text-center w-100"
          ></Modal.Title>
        </Modal.Header>

        <Modal.Body className="mobile-body">
          {
            <>
              <div className="row text-center">
                <div className="col-lg-12">
                  <img src={SuccessIcon} alt="success icon" />
                </div>

                <>
                  <h1>Congrats! Your bill is validated 🎉 </h1>
                  <div className="modal-div">
                    <p>And you've earned
                    

                    <img
                      src={GoldIcon}
                      alt="gold icon"
                      style={{ padding: 0, width: "20px" }}                     
                      />
                      <span style={{fontWeight: 700, marginRight: "3px"}}>{text}</span>                                          
                      points with DLF Malls. You can redeem your points 
                      <span style={{fontWeight: "700", textDecoration: "underline", marginLeft: "3px"}} onClick={()=>navigate("/rewards-catalogue")}>here</span>                     
                    </p>
                  </div>
                </>

                <div>
                  <button
                    className="radius0_button"
                    data-bs-dismiss="modal"
                    onClick={() => {
                      props.onHide();
                    }}
                  >
                    Back to Home!
                  </button>
                </div>
              </div>
            </>
          }
        </Modal.Body>

        <Modal.Footer></Modal.Footer>
      </Modal>
    </>
  );
};

export default ConditionalModalBillSucess;
